import useSEO from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { breadcrumbLd, webPageLd } from "@/lib/seo";
import useT from "@/i18n";

export default function LegalPage({ path, page, testId }) {
  const { t: T, lp } = useT();
  const { crumb, seoTitle: title, seoDesc: description, heading, sections } = T[page];
  const crumbs = [{ name: crumb, path }];
  useSEO({ title, description, path, jsonLd: [webPageLd({ title, description, path: lp(path) }), breadcrumbLd(crumbs, T.crumbs.home, lp)] });
  return (
    <div data-testid={testId}>
      <PageHeader crumbs={crumbs} badge={T.legal.badge} title={heading} intro={T.legal.updated(T.legal.date)} />
      <article className="max-w-3xl mx-auto safe-x sm:px-8 pb-16 prose-legal">
        {sections.map(([h, body]) => (
          <section key={h}>
            <h2>{h}</h2>
            {Array.isArray(body) ? <ul>{body.map((b) => <li key={b}>{b}</li>)}</ul> : <p>{body}</p>}
          </section>
        ))}
      </article>
    </div>
  );
}
